'use client';

import { useTranslations } from 'next-intl';
import AnimatedNumberSection from '../ui/Numbers';
import Video from './Video';

export default function ContactHeroView({ manufacturedParts }: { manufacturedParts: number }) {
    const t = useTranslations('ContactPage');

    return (
        <section className="w-full h-[calc(100vh-160px)] max-sm:h-[calc(100vh-100px)]">
            <div className="container mx-auto w-full flex h-full justify-between max-lg:flex-col lg:py-[180px] pt-[60px] pb-20 px-0 max-lg:px-4 gap-10">
                <AnimatedNumberSection
                    number={manufacturedParts}
                    className="text-[130px] max-lg:text-[80px] leading-tight"
                    maxWidth={300}
                />
                <h3 className="text-h4 sm:text-h3 font-medium text-white mt-auto max-sm:w-full w-2/3 text-right max-lg:self-end">
                    {t('professionalEngineering')}
                </h3>
            </div>
            <Video
                src="/video/business-strategy.webm"
                posterSrc="/img/contact-poster.webp"
                className="w-screen h-screen fixed top-0 left-0 right-0 bottom-0 z-negative"
            />
        </section>
    );
}
